import { setOutboundBinsForLine } from "services/utility/bins";
import { getBaseUom } from "services/utility/uoms";

export async function updateLineWithItem(item, line) {
  if (!item) {
    return line;
  }

  // transfer the appropriate properties from the new inventory
  // item to the line item
  const newLine = {
    ...line,
    item,
    bin: item.bin,
    description: item.description,
    weightunit: item.weightUnit,
    volumeunit: item.volumeUnit,
    uom: getBaseUom(item.uoms),
    class: item.class,
    serials: [],
    relatedRecords: { item },
    itemDetails: {
      itemWeight: item.weight,
      itemVolume: item.volume,
      itemUoms: item.uoms,
      serialTracking: item.serialTracking,
      lotTracking: item.lotTracking,
      type: item.type,
    },
  };

  return newLine;
}

export async function updateLineWithItemFromLocation(item, line, record) {
  if (!item) {
    return line;
  }

  const { fromLocation } = record;

  // transfer the appropriate properties from the new inventory
  // item to the line item
  const newLine = {
    ...line,
    item,
    description: item.description,
    weightunit: item.weightUnit,
    volumeunit: item.volumeUnit,
    uom: getBaseUom(item.uoms),
    class: item.class,
    serials: [],
    relatedRecords: { item },
    itemDetails: {
      itemWeight: item.weight,
      itemVolume: item.volume,
      itemUoms: item.uoms,
      serialTracking: item.serialTracking,
      lotTracking: item.lotTracking,
      type: item.type,
    },
  };

  return await setOutboundBinsForLine(fromLocation, newLine);
}
